"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.disabledStyles = void 0;
var _utils = require("@amzn/stencil-design-tokens/js/web/utils");
var _constants = require("../_form/constants");
var _utils2 = require("../utils");
const disabledStyles = _ref => {
  let {
    error,
    disabled,
    warning
  } = _ref;
  return disabled ? {
    backgroundColor: (0, _utils.token)('color.input.bg-disabled'),
    cursor: 'not-allowed',
    color: (0, _utils.token)('color.text.disabled'),
    WebkitTextFillColor: (0, _utils.token)('color.text.disabled') /* Safari */,
    opacity: 1,
    border: "".concat(_constants.INPUT_BORDER_WIDTH, "px solid ").concat((0, _utils.token)('color.input.border-disabled'))
  } : {
    ':hover': {
      border: "".concat(_constants.INPUT_BORDER_WIDTH, "px solid ").concat((0, _utils2.getColor)((0, _utils.token)('color.input.border-hover'), error, warning))
    }
  };
};
exports.disabledStyles = disabledStyles;